import { Box, Chip, TableCell, TableRow, Tooltip, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { formatWorkingDays } from "../format-utils"
import { ALLOCATED_FIXED_CONTRACT_TOOLTIP } from "./cost-breakdown-view-utils"
import { CostFigure } from "./cost-figure"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function CostBreakdownDetailRow({ item, currencySymbol, showBillingAdjustment, showTaskCount }) {
    const { hoursPerDay } = useBoundContext()
    const secondaryLabel = getSecondaryLabel()
    const hasActualHours = item.actualHours != null
    const hasAllocatedFixedCost = item.allocatedFixedCost > 0

    return (
        <TableRow data-cy="cost-resource-detail-row" sx={{ bgcolor: "action.hover" }}>
            <TableCell sx={{ pl: 6 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography variant="body2" color="text.secondary">
                            {item.label}
                        </Typography>
                        <If value={!!secondaryLabel}>
                            <Typography variant="caption" color="text.secondary">
                                {secondaryLabel}
                            </Typography>
                        </If>
                    </Box>
                    <If value={hasAllocatedFixedCost}>
                        <Tooltip title={ALLOCATED_FIXED_CONTRACT_TOOLTIP} arrow>
                            <Chip
                                label="Allocated fixed contract"
                                size="small"
                                color="info"
                                variant="outlined"
                                data-cy="allocated-fixed-contract-detail-chip"
                            />
                        </Tooltip>
                    </If>
                </Box>
            </TableCell>
            <If value={showTaskCount}>
                <TableCell align="right">
                    <Typography variant="body2" color="text.secondary">
                        {item.taskCount || 0}
                    </Typography>
                </TableCell>
            </If>
            <If value={showBillingAdjustment}>
                <TableCell align="right">
                    <If value={hasActualHours}>
                        <Typography variant="body2" color="text.secondary">
                            {formatWorkingDays(item.actualHours, hoursPerDay)}
                        </Typography>
                    </If>
                </TableCell>
            </If>
            <TableCell align="right">
                <Typography variant="body2" color="text.secondary">
                    {formatWorkingDays(item.totalHours, hoursPerDay)}
                </Typography>
            </TableCell>
            <TableCell align="right">
                <CostFigure value={item.totalCost} currencySymbol={currencySymbol} color="text.secondary" />
            </TableCell>
        </TableRow>
    )

    function getSecondaryLabel() {
        if (item.isOverride) return `Override ${currencySymbol}${item.hourlyRate}/hr`
        return item.secondaryLabel || ""
    }
}
